import { Link, useLocation } from 'react-router-dom'
import { FileText, Settings, BarChart3, Menu, X, CreditCard, Shield, Search } from 'lucide-react'
import { useState } from 'react'
import { useAuthStore } from '../../store/authStore'

export const Sidebar = () => {
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useAuthStore()

  const isAdmin = !!user?.is_admin

  const menuItems = [
    { path: '/projects', label: 'Анализ документа', icon: FileText },
    { path: '/search', label: 'Поиск по документу', icon: Search },
    { path: '/pricing', label: 'Тарифы и оплата', icon: CreditCard },
    // Справочники и админ-панель - только для администраторов
    ...(isAdmin
      ? [
          { path: '/settings', label: 'Справочники', icon: Settings },
          { path: '/admin', label: 'Администрирование', icon: Shield },
        ]
      : []),
//     { path: '/reports', label: 'Отчеты', icon: BarChart3 },
  ]

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  const closeSidebar = () => {
    setIsOpen(false)
  }

  return (
    <>
      {/* Кнопка меню для мобильных */}
      <button
        onClick={toggleSidebar}
        className="fixed top-4 left-4 z-40 md:hidden bg-blue-600 text-white p-2 rounded-lg"
        aria-label="Открыть меню"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Overlay для мобильных */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed md:static top-0 left-0 h-screen w-64 bg-gray-900 text-white z-35 transform transition-transform duration-300 ease-in-out md:transform-none ${
          isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
        }`}
      >
        <nav className="p-6 pt-20 md:pt-6">
          <ul className="space-y-2">
            {menuItems.map(({ path, label, icon: Icon }) => (
              <li key={path}>
                <Link
                  to={path}
                  onClick={closeSidebar}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    location.pathname === path
                      ? 'bg-blue-600'
                      : 'hover:bg-gray-800'
                  }`}
                >
                  <Icon size={20} />
                  <span className="truncate">{label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  )
}
